import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import DetailRequest from "../../magData/Flight/DetailRequest";
import DetailResponse from "../../magData/Flight/DetailResponse";

function FlightDetailPage() {

  return (
    <>

      <Container fluid >
        <Row>
          <Col sm={12} >
            <p className="page-title">Flight Detail Method</p>
          </Col>
          <Col sm={12} >
            <p>EndPoint : https://gdscpapi.parsgds.com/gateway/flight/detail</p>
          </Col>
          <Col sm={12} >
            <p> type : json (default)</p>
          </Col>
        </Row>
        <Row>
          <Col sm={12} >
            <p>Body Parameters</p>
          </Col>
          <Col sm={12} >

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>searchKey</td>
                  <td>Search Key</td>
                  <td>Guid </td>
                  <td><Badge bg="warning" text="dark">
                    Required
                  </Badge></td>
                </tr>
                <tr>
                  <td>gdsRefrenceID</td>
                  <td>Refrence ID</td>
                  <td>Guid </td>
                  <td><Badge bg="warning" text="dark">
                    Required
                  </Badge></td>
                </tr>
              </tbody>
            </Table>
          </Col>

        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Request Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(DetailRequest, null, 2)}
            </pre>


          </Col>
        </Row>

        {/* Response  */}
        <Row>
          <Col sm={12} >
            <p>Response Information</p>
          </Col>
          <Col sm={12} >

            <Table striped bordered>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Additional information</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>searchKey</td>
                  <td>Search Key</td>
                  <td>Guid </td>
                  <td></td>
                </tr>
                <tr>
                  <td>gdsRefrenceID</td>
                  <td>Refrence ID</td>
                  <td>Guid </td>
                  <td></td>
                </tr>
                <tr>
                  <td>baggage</td>
                  <td>Baggage</td>
                  <td>Object</td>
                  <td></td>
                </tr>
                <tr >
                  <td colSpan={4}> <Table bordered>
                    <tbody>
                      <tr>
                        <td>baggageInfoes</td>
                        <td>Baggage information per segment</td>
                        <td>Collection</td>
                        <td></td>
                      </tr>
                      <tr >
                        <td colSpan={4}> <Table bordered>
                          <tbody>
                            <tr>
                              <td>arrival</td>
                              <td>Arrival Airport</td>
                              <td>string </td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>baggage</td>
                              <td>Baggage information</td>
                              <td>string </td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>departure</td>
                              <td>Departure Airport</td>
                              <td>string </td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>flightNo</td>
                              <td>Flight Number to specify flight</td>
                              <td>string </td>
                              <td></td>
                            </tr>
                          </tbody></Table></td>

                      </tr>
                    </tbody></Table></td>

                </tr>

                <tr>
                  <td>services</td>
                  <td>Services Informetion</td>
                  <td>Collection</td>
                  <td></td>
                </tr>
                <tr >
                  <td colSpan={4}> <Table bordered>
                    <tbody>
                      <tr>
                        <td>passengerName</td>
                        <td>Passenger Informention</td>
                        <td>Obejct</td>
                        <td></td>
                      </tr>
                      <tr >
                        <td colSpan={4}> <Table bordered>
                          <tbody>
                            <tr>
                              <td>passengerFirstName</td>
                              <td>Passenger First name</td>
                              <td>string </td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>passengerMiddleName</td>
                              <td>Passenger middle name</td>
                              <td>string </td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>passengerLastName</td>
                              <td>Passenger last name</td>
                              <td>string </td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>passengerTitle</td>
                              <td>Passenger Title</td>
                              <td>string </td>
                              <td></td>
                            </tr>
                          </tbody></Table></td>

                      </tr>
                      <tr>
                        <td>description</td>
                        <td>Extra Service Description</td>
                        <td>string</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>serviceId</td>
                        <td>Extra Service identifier</td>
                        <td>string</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>behavior</td>
                        <td>Behavior</td>
                        <td>Integer</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>serviceCost</td>
                        <td>Service Cost</td>
                        <td>Obejct</td>
                        <td></td>
                      </tr>
                      <tr >
                        <td colSpan={4}> <Table bordered>
                          <tbody>
                            <tr>
                              <td>amount</td>
                              <td>Amount</td>
                              <td>decimal  </td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>currency</td>
                              <td>Currency</td>
                              <td>string </td>
                              <td></td>
                            </tr>
                          </tbody></Table></td>
                      </tr>
                    </tbody></Table></td>

                </tr>

                <tr>
                  <td>rule</td>
                  <td>Fare Rule</td>
                  <td>Collection</td>
                  <td></td>
                </tr>
                <tr >
                  <td colSpan={4}> <Table bordered>
                    <tbody>
                      <tr>
                        <td>fareType</td>
                        <td>Fare Type</td>
                        <td>Integer</td>
                        <td></td>
                      </tr>
                      <tr>
                        <td>fareRules</td>
                        <td>Fare rule information</td>
                        <td>Collection </td>
                        <td></td>
                      </tr>
                      <tr >
                        <td colSpan={4}> <Table bordered>
                          <tbody>
                            <tr>
                              <td>airline</td>
                              <td>Airline Code</td>
                              <td>string </td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>cityPair</td>
                              <td>PCity Pair</td>
                              <td>string </td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>ruleDetails</td>
                              <td>Fare Rule information</td>
                              <td>string </td>
                              <td></td>
                            </tr>
                            <tr >
                        <td colSpan={4}> <Table bordered>
                          <tbody>
                            <tr>
                              <td>category</td>
                              <td>Category of Fare Rule</td>
                              <td>string  </td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>rules</td>
                              <td>Rules</td>
                              <td>string </td>
                              <td></td>
                            </tr>
                            <tr>
                              <td>messageDirection</td>
                              <td></td>
                              <td>string </td>
                              <td></td>
                            </tr>
                          </tbody></Table></td>
                      </tr>
                          </tbody></Table></td>

                      </tr>
             
                     
                    </tbody></Table></td>

                </tr>
              </tbody>
            </Table>
          </Col>

        </Row>
        <Row>
          <Col sm={12}><span className="code-section-title">Response Formats - application/json, text/json</span></Col>
          <Col sm={12}>

            <pre className="code-section">
              {JSON.stringify(DetailResponse, null, 2)}
            </pre>


          </Col>
        </Row>
      </Container>

    </>
  );
}

export default FlightDetailPage;